/* eslint-disable jquery/no-attr */
import $ from 'jquery';
import { fetchOptionsPost } from '../util/fetchutils'; // eslint-disable-line import/named
import { findFormFields, onEvent } from '../util/domutils'; // eslint-disable-line import/named
import clientSideValidation from '../components/clientSideValidation';
import newsletter from '../newsletter/newsletter';
import base from '~base';

const baseResetPassword = base.resetPassword;

/**
 * Event handler that toggles the UI elements, corresponding to whether
 * the customer has chosen to sue a password to login or proceed as guest
 *
 * @param  {CustomEvent} e The event raised on change of a password toggle radio button
 */
const togglePasswordElements = (e) => {
  const usePassword = (e.delegateTarget.value === 'true');
  const passwordProperties = document.querySelector('.password-properties');

  passwordProperties.classList.toggle('d-block', usePassword);
  findFormFields(passwordProperties).forEach((el) => {
    el.disabled = !usePassword;
  });
};

base.resetPassword = () => {
  // Replace the handling of the AJAX response in the base code
  // with directly placing the response string on the page;
  // the backend is altered to render a template instead of returning JSON
  baseResetPassword();

  // Use jQuery, as it's the only way to hook into the base AJAX call
  $(document).on('ajaxComplete', (e, xhr, options) => {
    const form = document.querySelector('.reset-password-form');

    if (form && options.url === form.getAttribute('action')) {
      // jQuery is used as it provides a nicer API to replace elements
      $(form).replaceWith(xhr.responseText);
      clientSideValidation.invalid();

      // Call the base code to reattach the submit event listener on the replaced form
      baseResetPassword();
    }
  });

  $(document).off('click', '.forgot-password > a, .login__forgot-password > a');
  $(document).on('click', '.forgot-password > a, .login__forgot-password > a', function () {
    const href = $(this).attr('href'); // eslint-disable-line jquery/no-attr
    const existingEmail = $('#login-form-email').val(); // eslint-disable-line jquery/no-val
    let newUrl = href;

    if (existingEmail) {
      newUrl = `${href}?email=${existingEmail}`;
    }
    window.location.href = newUrl;
    return false;
  });
};

base.preRegister = () => {
  onEvent(document, 'submit', '.login__pre-register', async (event) => {
    event.preventDefault();

    const form = event.target;
    const options = fetchOptionsPost(new FormData(form));
    const response = await fetch(form.action, options);
    const data = await response.json();

    if (data.redirectUrl) {
      window.location.href = data.redirectUrl;
    } else if (data.errorEmailUsed) {
      const errorContainer = form.querySelector('.invalid-feedback');

      errorContainer.innerHTML = data.errorEmailUsed;
      errorContainer.classList.remove('d-none');
      errorContainer.classList.add('d-block');
    }
  });
};

base.checkoutLoginPasswordToggle = () => {
  $(document).ready(() => {
    onEvent(document, 'change', '[name="usePassword"]', togglePasswordElements);
  });
};

base.addCountryCodeSelector = () => {
  $(document).ready(() => {
    const $dialCode = $('#dialCode');
    if ($dialCode) {
      const allowedCountries = $dialCode.attr('allowedLocales');
      const defaultCountryCode = $dialCode.attr('defaultCountryCode');
      const $onlyCountries = allowedCountries ? allowedCountries.split(',') : '';
      $('#dialCode').intlTelInput({
        allowDropdown: true,
        initialCountry: defaultCountryCode,
        formatOnDisplay: true,
        separateDialCode: true,
        page: 'checkout-page',
        onlyCountries: $onlyCountries,
        dropdownContainer: $('.country-dial-code'),
      });
    }
  });
};

base.includeOptInFormElementsVisibility = newsletter.includeOptInFormElementsVisibility;

export default base;
